module.exports = __webpack_public_path__ + "media/images/mobile/home/bg03-17199542bc1235148613600d68037e9d.png";